import {
  SET_PROMPTS,
  SET_SYSTEM_PROMPTS,
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  list: [],
  count: 0,

  systemPrompts: [],
};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case SET_PROMPTS:
      return {
        ...state,
        list: action.data.list,
        count: action.data.count,
      }

    case SET_SYSTEM_PROMPTS:
      return {
        ...state,
        systemPrompts: action.data.list,
      }

    default:
      return state

  }
}
